/* eslint-disable no-nested-ternary */
import React, { useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
// Api
import { getCard } from 'api/credit-card'
import { getShipping } from 'api/shipping'

import { MeContext } from 'contexts/me'
// Assets
import { WaynicardAddressImage } from 'assets/icons'

import { trackEvent } from 'analytics/trackFunctions'
// Components
import PageWrapper from 'components/PageWrapper'
import PrimaryButton from 'components/primaryButton'
import storage from 'utils/storage'
import LoadingScreen from 'components/LoadingScreen'

const WayniCardSuccess = () => {
  const [shipmentData, setShipmentData] = useState(null)
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()
  const { me } = useContext(MeContext)

  function tracker(data) {
    trackEvent({
      eventName: 'bille_pantalla_tarjeta_fisica_ok',
      props: {
        provincia: data.region,
        ciudad: data.city,
        calle: data.street_name,
        altura: data.street_number,
        piso: data.floor,
        cp: data.zip_code,
        depto: data.apartment
      }
    })
  }

  useEffect(() => {
    setLoading(true)

    getCard({ data: me?.user?.uuid, type: 'PHYSICAL' })
      .then((res) => res.data?.shipment_id)
      .then((shipment_id) => {
        if (shipment_id) {
          getShipping(shipment_id).then((res) => {
            if (res.success) {
              setShipmentData(res.data.result)
              tracker(res.data.result.address)
            }
          })
        } else {
          setShipmentData({ address: storage.get('address') })
          tracker(storage.get('address'))
        }
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [])

  if (!shipmentData || loading) return <LoadingScreen />

  return (
    <PageWrapper viewSelected='/mis-tarjetas' title='Tarjeta Wayni'>
      <section className='md:max-w-564 md:flex md:items-end md:flex-col mx-auto flex justify-between flex-col'>
        <div className='w-full  items-center text-center px-0'>
          <h1 className='font-bold text-2xl text-black mt-5'>
            ¡Tu Tarjeta Wayni <br /> ya fue solicitada!
          </h1>
          <WaynicardAddressImage classname='flex w-full items-center ' />
          <div className='text-black text-xs sm:h-60 w-full flex justify-evenly sm:justify-around flex-col px-3 '>
            <span className='font-medium mb-2 sm:mb-0'>
              <span className='font-bold'>Te llegará en la dirección:</span>{' '}
              {shipmentData && (
                <>
                  {shipmentData?.address?.street_name}{' '}
                  {shipmentData?.address?.street_number}
                </>
              )}
            </span>
            <span className='font-medium'>
              Recordá que el envío demora 5 días hábiles <br /> a partir del día
              en que la solicitaste
            </span>
            <span className='font-bold mt-4 sm:my-0'>
              La podrá recibir cualquier persona mayor de 18 años
            </span>

            {loading ? (
              <Skeleton className='mt-4' />
            ) : !shipmentData?.courier?.tracking_url ||
              shipmentData?.courier?.tracking_url === null ? (
              <span className='mt-4'>
                Te estamos generando un número de seguimiento
              </span>
            ) : (
              <>
                <span className='font-medium mt-4'>
                  En el siguiente link podrás ver el <br />
                  seguimiento de tu envío:{' '}
                </span>
                <a
                  target='_blank'
                  href={shipmentData?.courier?.tracking_url}
                  className='font-bold xs:text-xs my-2 text-blue-900'
                  rel='noreferrer'
                >
                  Seguir mi tarjeta
                </a>
              </>
            )}
          </div>
        </div>

        <div className='sm:w-1/2 sm:mx-auto px-3'>
          <PrimaryButton
            buttonText='ir a inicio'
            className='mb-8'
            outlined={false}
            type='button'
            primaryButtonFunction={() => {
              navigate('/home')
            }}
          />
        </div>
      </section>
    </PageWrapper>
  )
}
export default WayniCardSuccess
